// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"32":"7a72bd86","496":"7a72bd86","646":"490fd847","830":"cff14826","943":"7a72bd86"}[chunkId] + ".chunk.css";
};